// @ts-nocheck

import { Loader } from "@googlemaps/js-api-loader";
import { useDebounceFn } from "@vueuse/core";
import { merge } from "lodash";
import { defineStore } from "pinia";
//TODO: deze ook in frontend? of deze gebruiken?
import { api } from "../scripts/api.ts";

export const useAddressStore = defineStore("address", () => {
    const loader = new Loader({
        version: "weekly",
        apiKey: import.meta.env.VITE_GOOGLE_API,
        libraries: ["places"],
    });

    const createAddress = async (data) => {
        return new Promise(async (resolve, reject) => {
            await api()
                .post("/site/address/store/", data)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    if (error.response) {
                        resolve(error.response.data);
                    } else {
                        reject(error);
                    }
                });
        });
    };

    const updateAddress = async (id, data): Promise<T> => {
        return new Promise<T>(async (resolve, reject): Promise<void> => {
            await api()
                .post(
                    "/site/address/" + id + "/update/",
                    merge(data, { _method: "PUT" }),
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    if (error.response) {
                        resolve(error.response.data);
                    } else {
                        reject(error);
                    }
                });
        });
    };

    const deleteAddress = async (id): Promise<T> => {
        return new Promise<T>(async (resolve, reject): Promise<void> => {
            await api()
                .post("/site/address/" + id + "/delete/", { _method: "DELETE" })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    if (error.response) {
                        resolve(error.response.data);
                    } else {
                        reject(error);
                    }
                });
        });
    };

    const getSearchResults = useDebounceFn(async (input: string) => {
        return new Promise(async (resolve, reject) => {
            try {
                //https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest
                const Places = await loader.importLibrary("places");
                const { suggestions } =
                    await Places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
                        {
                            input: input,
                            includedPrimaryTypes: [
                                "street_address",
                                "post_box",
                                "premise",
                            ],
                            // region: 'nl' potentiele beperkingsoptie
                        },
                    );

                const response = [];
                for (const suggestion of suggestions) {
                    response.push({
                        place_id: suggestion.placePrediction.placeId,
                        description: suggestion.placePrediction.text.text,
                    });
                }

                resolve(response);
            } catch (e) {
                reject(e);
            }
        });
    }, 500);

    interface AddressDetails {
        house_number: string;
        house_number_addition: string;
        street: string;
        city: string;
        postal: string;
        country: string;
        address_line_1: string;
    }

    const getAddressDetails = async (
        places_id: string,
        splitAddressCountries: Array<string> = [],
    ): Promise<AddressDetails> => {
        return new Promise(async (resolve, reject): Promise<void> => {
            try {
                const Places = await loader.importLibrary("places");
                const place: Places.Place = new Places.Place({
                    id: places_id,
                    requestedLanguage: "en", // optional
                });
                // Call fetchFields, passing the needed data fields.
                await place.fetchFields({
                    fields: ["addressComponents", "formattedAddress"],
                });

                const returnValue: Partial<AddressDetails> = {};
                if (place === null) {
                    reject("Empty Response");
                    return;
                }

                if (
                    Object.hasOwn(place, "addressComponents") &&
                    place.addressComponents !== undefined
                ) {
                    reject("No address components found.");
                    return;
                }

                for (const [key, value] of Object.entries(
                    place.addressComponents,
                )) {
                    if (value.types.includes("country"))
                        returnValue.country = value.shortText; //TODO: type check

                    //Komt alleen nog zonder toevoeging terug
                    if (value.types.includes("street_number")) {
                        const split = value.longText.split(/^(\d+)(.*)$/);
                        returnValue.house_number = split[1];
                        returnValue.house_number_addition = split[2];
                    }
                    if (value.types.includes("route"))
                        returnValue.street = value.longText;
                    if (
                        value.types.includes("locality") ||
                        value.types.includes("postal_town")
                    )
                        returnValue.city = value.longText;
                    if (value.types.includes("postal_code"))
                        returnValue.postal = value.longText;
                }
                if (
                    returnValue.country &&
                    !splitAddressCountries.includes(returnValue.country)
                ) {
                    returnValue.address_line_1 =
                        place.formattedAddress.split(",")[0];
                }
                resolve(returnValue);
            } catch (e) {
                reject(e);
            }
        });
    };

    return {
        getSearchResults,
        getAddressDetails,
        createAddress,
        updateAddress,
        deleteAddress,
    };
});
